module.exports = "https://coursera_assets.s3.amazonaws.com/images/bec969ebdf378418f18c315b0bb47c6c.png";